import { ToastDesignTokens } from '@primeuix/themes/types/toast';

export const TOAST_STYLES: ToastDesignTokens = {
  root: {
    width: 'fit-content',
  },
  colorScheme: {
    light: {
      success: {
        color: '{green.600}',
        detailColor: '{green.600}',
      },
      info: {
        color: '{blue.600}',
        detailColor: '{blue.600}',
      },
      error: {
        color: '{red.600}',
        detailColor: '{red.600}',
      },
    },
  },
};
